import React from 'react';
import GroupCardAvatarStack from './GroupCardAvatarStack';
import GroupChildCard from './GroupChildCard';
import { useAppDispatch } from '../app/redux/useAppSelector';
import { MenuItem } from '../components/Menu';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import trashIcon from '../icons/non-prefilled/16x16/trash.svg';
import { UIActions } from '../ui/uiSlice';
import groupPath from '../utils/url/groupPath';

const GROUP_SUBGROUP_CARD_FRAGMENT = gql(`
  fragment GroupSubgroupCard_group on Group {
    id
    name
    members {
      id
    }
    owners {
      id
    }
    ...groupPath_group
    ...GroupCardAvatarStack_group
  }
`);

interface GroupSubgroupCardProps {
  group: DocumentType<typeof GROUP_SUBGROUP_CARD_FRAGMENT>;
  onRemove?: () => Promise<unknown>;
}

const GroupSubgroupCard = ({ group, onRemove }: GroupSubgroupCardProps) => {
  const dispatch = useAppDispatch();
  const { name, members, owners } = group;
  const hasUsers = members.length > 0 || owners.length > 0;

  const showToast = (message: string) => {
    dispatch(
      UIActions.pushToast({
        level: 'success',
        message,
      }),
    );
  };

  return (
    <GroupChildCard
      to={groupPath(group) || ''}
      avatars={hasUsers ? <GroupCardAvatarStack group={group} /> : null}
      title={name}
      description="Group"
      menuItems={
        onRemove && (
          <MenuItem
            danger
            icon={trashIcon}
            onClick={() =>
              onRemove().then(() =>
                showToast(`${name} has been removed from the group.`),
              )
            }
          >
            Remove group
          </MenuItem>
        )
      }
    />
  );
};

export default GroupSubgroupCard;
